import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pop-anuncio',
  templateUrl: './pop-anuncio.component.html',
  styleUrls: ['./pop-anuncio.component.scss'],
})
export class PopAnuncioComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
